export default {
  SEARCH_BOX_PLACEHOLDER: 'Search for parts among 50,000 products...',

  GO_TEXT: 'Go',
  CLEAR_TEXT: 'Clear',

  GARAGE_ICON: '<span class="custom-garage-icon" template="icons/garageIcon"></span>',
};
